<template>
  <div class="page flex-col">
    <v-head title="报名提交成功"></v-head>

    <div class="box_1 flex-col"></div>
    <div class="box_2 flex-col">
      <div class="box_3 flex-col">
        <div class="image-text_1 flex-col">
          <img class="image_3" referrerpolicy="no-referrer" src="../../../assets/images/user/img.png" />
          <div class="text-group_1 flex-col">
            <span class="text_1">您已成功报名会议</span>
            <!-- <span class="text_2">审核结果将以短信的方式通知您，请耐心等待</span> -->
          </div>
        </div>
        <!-- <button class="button_1 flex-col" @click="onClick_1">
          <span class="text_3">前往报名管理</span>
        </button> -->
        <button class="button_1 flex-col" @click="onClick_2">
          <span class="text_3">交纳注册费</span>
        </button>
        <button class="button_2 flex-col" @click="onClick_1">
          <span class="text_3">暂不支付</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import vHead from "../../../components/Subhead.vue"

  export default {
    data() {
      return {
        constants: {},
      }
    },
    components: {
      vHead,
    },
    methods: {
      onClick_1() {
        this.$router.push({
          name: "SignUpmeetingCenter",
        })
      },
      onClick_2() {
        let signupPayList = sessionStorage.getItem("Paypage")
        if (signupPayList) {
          let signupPayInfo = JSON.parse(signupPayList)
          this.$router.push({
            name: "Paypage",
            query: {
              meetingId: signupPayInfo.meetingId,
              orderId: signupPayInfo.orderId,
              sourceName: "meetPaymentList",
            },
          })
        }

      },
    },
  }
</script>
<style scoped>
  .page {
    width: 414px;
    overflow: hidden;
  }

  .image_1 {
    width: 414px;
    height: 38px;
    margin: 859px 0 -1px 0;
  }

  .box_1 {
    position: absolute;
    left: 0;
    top: 0;
    width: 414px;
  }

  .box_2 {
    position: absolute;
    left: 0;
    top: 0;
    width: 380px;
    padding-top: 18px;
  }

  .image_2 {
    width: 361px;
    height: 17px;
    margin: 0 16px 0 37px;
  }

  .box_3 {
    padding: 14px 0 0 0;
    text-align: center;
  }

  .nav-bar_1 {
    background: none;
    height: 48px;
  }

  .nav-bar_1 .van-nav-bar__content {
    height: 100%;
  }

  .nav-bar_1 .van-nav-bar__left {
    padding: 0 0 0 26px;
    align-items: start;
  }

  .icon_1 {
    width: 26px;
    height: 26px;
    margin-top: 12px;
  }

  .image-text_1 {
    margin: 157px auto;
    text-align: center;
  }

  .image_3 {
    width: 100px;
    height: 72px;
    margin: 0 auto;
  }

  .text-group_1 {
    margin-top: 14px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    align-self: center;
  }

  .text_2 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 14px;
  }

  .button_1 {
    background-color: rgba(246, 109, 17, 1);
    border-radius: 28px;
    margin: 30px auto 0;
    padding: 6px 21px 5px 21px;
  }

  .button_2 {
    background-color: rgb(17, 124, 246);
    border-radius: 28px;
    margin-left: 20px;
    padding: 6px 21px 5px 21px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image_4 {
    width: 414px;
    height: 38px;
    margin-top: -1px;
  }
</style>